/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Body_send_notification_to_user_notification_user_post = {
    properties: {
        user_ids: {
            type: 'array',
            contains: {
                type: 'number',
            },
            isRequired: true,
        },
        title: {
            type: 'TranslationBase',
            isRequired: true,
        },
        body: {
            type: 'TranslationBase',
            isRequired: true,
        },
        data: {
            type: 'dictionary',
            contains: {
                properties: {
                },
            },
            isRequired: true,
        },
    },
} as const;
